"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var ColorPatterns;
(function (ColorPatterns) {
    ColorPatterns["inverse"] = "GREY.BLACK";
    ColorPatterns["success"] = "UTILITY.SUCCESS";
    ColorPatterns["danger"] = "UTILITY.ERROR";
    ColorPatterns["warning"] = "UTILITY.WARN";
    ColorPatterns["informational"] = "UTILITY.ACTION";
    ColorPatterns["inactive"] = "GREY[\"100\"]";
    ColorPatterns["primary"] = "GREY.WHITE";
})(ColorPatterns || (ColorPatterns = {}));
var makeColorPatternStyles = function (colorPattern, theme) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(ColorPatterns[colorPattern]), theme)); };
var LowPriorityColorPatterns;
(function (LowPriorityColorPatterns) {
    LowPriorityColorPatterns["success"] = "GREEN[\"100\"]";
    LowPriorityColorPatterns["danger"] = "RED[\"100\"]";
    LowPriorityColorPatterns["warning"] = "YELLOW[\"100\"]";
    LowPriorityColorPatterns["informational"] = "BLUE[\"100\"]";
})(LowPriorityColorPatterns || (LowPriorityColorPatterns = {}));
var makeLowPriorityColorPatternStyles = function (colorPattern, theme) { return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(LowPriorityColorPatterns[colorPattern]), theme)); };
var getIconAndTextColor = function (_a) {
    var priority = _a.priority, colorPattern = _a.colorPattern;
    if (priority === 'low') {
        switch (colorPattern) {
            case 'success':
                return 'GREEN["600"]';
            case 'warning':
                return 'YELLOW["600"]';
            case 'danger':
                return 'RED["600"]';
            default:
                return 'BLUE["500"]';
        }
    }
    else {
        switch (true) {
            case colorPattern === 'warning':
            case colorPattern === 'success':
                return 'GREY["900"]';
            case colorPattern === 'inactive':
            case colorPattern === 'primary':
                return 'GREY["600"]';
            default:
                return 'GREY.WHITE';
        }
    }
};
var getPaddingX = function (pattern) {
    if (pattern === 'notification') {
        return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      padding-left: 0.25rem;\n      padding-right: 0.25rem;\n    "], ["\n      padding-left: 0.25rem;\n      padding-right: 0.25rem;\n    "])));
    }
    else
        return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      padding-left: 0.5rem;\n      padding-right: 0.5rem;\n    "], ["\n      padding-left: 0.5rem;\n      padding-right: 0.5rem;\n    "])));
};
var getPaddingY = function (pattern, withIcon) {
    if (pattern === 'notification') {
        return (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      padding-top: 0;\n      padding-bottom: 0;\n    "], ["\n      padding-top: 0;\n      padding-bottom: 0;\n    "])));
    }
    else if (withIcon && pattern !== 'video') {
        return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      padding-top: 0.375rem;\n      padding-bottom: 0.375rem;\n    "], ["\n      padding-top: 0.375rem;\n      padding-bottom: 0.375rem;\n    "])));
    }
    else
        return (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      padding-top: 0.125rem;\n      padding-bottom: 0.125rem;\n    "], ["\n      padding-top: 0.125rem;\n      padding-bottom: 0.125rem;\n    "])));
};
var videoPatternStyles = (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n\n  svg {\n    color: ", ";\n  }\n"], ["\n  background: ", ";\n  color: ", ";\n\n  svg {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.BLACK', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
}, function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
});
exports.Root = styled_components_1.default.div.withConfig({
    shouldForwardProp: function (prop) {
        return !['shape', 'colorPattern', 'withIcon', 'pattern', 'priority'].includes(prop);
    },
})(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  border-radius: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n\n  svg {\n    color: ", ";\n  }\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  min-height: 1rem;\n  min-width: 1rem;\n"], ["\n  border-radius: ", ";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: ", ";\n\n  svg {\n    color: ", ";\n  }\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  min-height: 1rem;\n  min-width: 1rem;\n"])), function (_a) {
    var shape = _a.shape, theme = _a.theme;
    return shape === 'simple'
        ? (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS_DEFAULT', theme)
        : (0, ui_helper_deep_branding_1.getFromTheme)('LINE.RADIUS.XLARGE', theme);
}, function (_a) {
    var priority = _a.priority, colorPattern = _a.colorPattern, theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(getIconAndTextColor({ priority: priority, colorPattern: colorPattern })), theme);
}, function (_a) {
    var priority = _a.priority, colorPattern = _a.colorPattern, theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.".concat(getIconAndTextColor({ priority: priority, colorPattern: colorPattern })), theme);
}, function (_a) {
    var pattern = _a.pattern;
    return getPaddingX(pattern);
}, function (_a) {
    var pattern = _a.pattern, withIcon = _a.withIcon;
    return getPaddingY(pattern, withIcon);
}, function (props) { return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'colorPattern', makeColorPatternStyles); }, function (props) {
    return props.priority === 'low' &&
        (0, ui_helper_props_to_styles_1.makeStyles)(props, 'colorPattern', makeLowPriorityColorPatternStyles);
}, function (props) { return props.pattern === 'video' && videoPatternStyles; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=root.js.map